<nb-card class="dialog-card test-dispatch-dialog">
  <nb-card-header>
    <h5>{{ "pages.dozent.exercises.testExercise" | translate }}</h5>
  </nb-card-header>
  <nb-card-body>
    <app-page-loader *ngIf="loading"></app-page-loader>

    <ng-container *ngIf="!loading">
      <div class="form-group">
        <label class="label">{{ "pages.dozent.participants.selectExercise" | translate }} *</label>
        <nb-select
          fullWidth
          placeholder="{{ 'pages.dozent.participants.selectExercisePlaceholder' | translate }}"
          [(selected)]="selectedExerciseId"
        >
          <nb-option *ngFor="let ex of exercises" [value]="ex.id">
            {{ ex.title }} <span class="muted">({{ ex.exercise_type }})</span>
          </nb-option>
        </nb-select>
        <p class="empty-hint" *ngIf="exercises.length === 0">
          {{ "pages.dozent.participants.noOwnExercises" | translate }}
        </p>
      </div>

      <div class="form-group" *ngIf="bots.length > 1">
        <label class="label">{{ "pages.dozent.participants.selectBot" | translate }} *</label>
        <nb-select fullWidth [(selected)]="selectedBotId">
          <nb-option *ngFor="let b of bots" [value]="b.id">
            <div class="twin-agent-option">
              <span class="twin-agent-option__name">{{ botDisplayName(b) }}</span>
              <span class="twin-agent-option__tags">
                <span class="twin-agent-option__tag" *ngIf="botExternalName(b)">
                  {{ "pages.dozent.participants.externalName" | translate }}:
                  {{ botExternalName(b) }}
                </span>
                <span class="twin-agent-option__tag" *ngIf="botInternalName(b)">
                  {{ "pages.dozent.participants.internalName" | translate }}:
                  {{ botInternalName(b) }}
                </span>
              </span>
            </div>
          </nb-option>
        </nb-select>
      </div>
      <p class="empty-hint" *ngIf="bots.length === 0">
        {{ "pages.dozent.participants.noDozentBots" | translate }}
      </p>

      <div class="recipient-panel" *ngIf="recipient; else noRecipient">
        <span class="panel-label">{{ "pages.dozent.exercises.testRecipient" | translate }}</span>
        <strong>{{ recipientLabel() }}</strong>
        <span class="muted block" *ngIf="recipient.email">{{ recipient.email }}</span>
      </div>
      <ng-template #noRecipient>
        <p class="empty-hint">
          {{ "pages.dozent.exercises.noTestRecipient" | translate }}
        </p>
      </ng-template>

      <div class="form-group">
        <label class="label">{{ "pages.dozent.participants.scheduledPublishAt" | translate }}</label>
        <input nbInput fullWidth type="datetime-local" [(ngModel)]="scheduledPublishAt" />
        <p class="empty-hint">
          {{ "pages.dozent.exercises.testScheduledPublishAtHint" | translate }}
        </p>
      </div>

      <div class="form-group">
        <label class="label">{{ "pages.dozent.participants.dueDate" | translate }}</label>
        <input nbInput fullWidth type="datetime-local" [(ngModel)]="dueDate" />
      </div>

      <div class="form-group">
        <label class="label">{{ "pages.dozent.participants.instructionsOptional" | translate }}</label>
        <textarea nbInput fullWidth rows="2" [(ngModel)]="instructions"></textarea>
      </div>
    </ng-container>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton ghost (click)="close()">
      {{ "buttons.cancel" | translate }}
    </button>
    <button
      nbButton
      status="primary"
      (click)="submit()"
      [disabled]="!canSubmit()"
      [nbSpinner]="saving"
      nbSpinnerSize="tiny"
      nbSpinnerStatus="control"
    >
      <nb-icon icon="paper-plane-outline" *ngIf="!saving"></nb-icon>
      {{ "pages.dozent.participants.dispatch" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
